import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import CookieManager from '../CookieManager';

const LoginForm = ({ errorMessage, handleLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();

  /*
    NOTE:
      viene eseguito una sola volta al mount del componente
      serve solo a inizializzare lo stato UI leggendo da localStorage
  */
  useEffect(() => {
    const storedIsLoggedIn = localStorage.getItem('isLoggedIn');
    setIsLoggedIn(storedIsLoggedIn === 'true' ? true : false);
  }, []);

  // rimuovi cookie e pulisci stato UI
  const handleLogout = () => {
    CookieManager.remove();
    localStorage.removeItem('isLoggedIn');
    setIsLoggedIn(false);
    setPassword('');
    setUsername('');
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isLoggedIn) {
      handleLogout();
      return;
    }

    const ok = await handleLogin(username, password);

    if (ok) {
      // solo UI — NON consideriamo questo come prova di autenticazione reale
      localStorage.setItem('isLoggedIn', 'true');
      setIsLoggedIn(true);
      setPassword('');
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center vh-100">
      <div className="bg-light border rounded p-3" style={{ width: '30%' }}>
        <form onSubmit={handleSubmit}>
          {errorMessage && (
            <label className="text-danger mb-3">{errorMessage}</label> /* display error message */
          )}

          {isLoggedIn && (
            <div className="mb-3">
              <strong>Sei connesso</strong>
            </div>
          )}

          <div className="form-group mb-3">
            <input
              type="text"
              className="form-control"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder={isLoggedIn ? "*******" : "Username"}
              disabled={isLoggedIn}
            />
          </div>
          <div className="form-group mb-3">
            <input
              type="password"
              className="form-control"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={isLoggedIn ? "*******" : "Password"}
              disabled={isLoggedIn}
            />
          </div>
          <div className="form-group d-flex justify-content-end">
            {isLoggedIn && (
              <button
                type="button"
                className="btn btn-primary btn-sm me-2"
                onClick={() => navigate('/', { replace: true })}
              >
                Apri App
              </button>
            )}
            <button
              type="submit"
              className={isLoggedIn ? "btn btn-danger btn-sm" : "btn btn-primary btn-sm"}
              style={{ width: 'auto' }}
            >
              <FontAwesomeIcon icon="user" />
              {isLoggedIn ? ` Logout` : " Login"}
            </button>
          </div>
        </form>
      </div >
    </div >
  );
};

export default LoginForm;